/// <reference types="@angular/localize" />
import './app/instrument';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { frontendLogger } from './app/instrument';

frontendLogger.info('Init application', { screen: 'dashboard' });

platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
